import React, { memo } from 'react'
import { EAgroservicesTypes } from '@/components/resolvers/AgroServices/enums'
import { AgroserviceGeneralCard } from './components/AgroservicesCards'
import { AGROSERVICES_CARDS } from './constants'
import { messages } from './messages'
import './styles.scss'

const AgroServices: React.FC = () => {
  return (
    <div
      className="
        page-wrapper
        index-agroservices-container
        space-holder96-from-sm
        space-holder40-sm
        page-wrapper_no-mobile
        space-holder-top40-sm
      "
    >
      <div className="index-agroservices">
        {AGROSERVICES_CARDS.map(agroService => {
          const { productId, url, blockType, oldPrice, price, paymentPeriod, mainActionText, logo } = agroService

          if (!url) return null

          const title = messages.card.title[productId as keyof typeof messages.card.title]
          const description = messages.card.description[productId as keyof typeof messages.card.description]

          return (
            <AgroserviceGeneralCard
              className={blockType === EAgroservicesTypes.WIDE ? 'index-agroservices__wide' : ''}
              productId={productId}
              key={productId}
              mainActionText={mainActionText}
              title={title}
              description={description}
              logo={logo}
              price={price}
              oldPrice={oldPrice}
              paymentPeriod={paymentPeriod}
              url={url}
            />
          )
        })}
      </div>
    </div>
  )
}

export default memo(AgroServices)
